import { render, staticRenderFns } from "./ViewProgramDetailsMobile.vue?vue&type=template&id=6854a4ed&lang=pug&"
import script from "./ViewProgramDetailsMobile.vue?vue&type=script&lang=js&"
export * from "./ViewProgramDetailsMobile.vue?vue&type=script&lang=js&"
import style0 from "./ViewProgramDetailsMobile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports